// Murke Dirty Graphics Portfolio - Actual Artwork Data

// Kingfish Protocol Series
export const kingfishProtocol = [
  {
    id: 1,
    title: "Aviated Gather",
    year: "2024",
    dimensions: "13x13",
    series: "Kingfish Protocol",
    image: "/aviated_gather.jpg"
  },
  {
    id: 2,
    title: "Feather Site",
    year: "2024",
    dimensions: "13x13",
    series: "Kingfish Protocol",
    image: "/feather_site.jpg"
  },
  {
    id: 3,
    title: "Flight Offense",
    year: "2024",
    dimensions: "13x13",
    series: "Kingfish Protocol",
    image: "/flight_offense.jpg"
  },
  {
    id: 4,
    title: "Precise Posture",
    year: "2024",
    dimensions: "13x13",
    series: "Kingfish Protocol",
    image: "/precise_posture.jpg"
  },
  {
    id: 5,
    title: "Two Two",
    year: "2024",
    dimensions: "13x13",
    series: "Kingfish Protocol",
    image: "/two_two.jpg"
  }
];

// Unexpected Autopsy Series
export const unexpectedAutopsy = [
  {
    id: 6,
    title: "Quatre Clear",
    year: "2024",
    dimensions: "13x13",
    series: "Unexpected Autopsy",
    image: "/quatre_clear.jpg"
  },
  {
    id: 7,
    title: "Noir Banter",
    year: "2024",
    dimensions: "13x13",
    series: "Unexpected Autopsy",
    image: "/noir_banter.jpg"
  },
  {
    id: 8,
    title: "Noir March",
    year: "2024",
    dimensions: "13x13",
    series: "Unexpected Autopsy",
    image: "/noir_march.jpg"
  },
  {
    id: 9,
    title: "Luminous",
    year: "2024",
    dimensions: "13x13",
    series: "Unexpected Autopsy",
    image: "/luminous.jpg"
  }
];

// Singularities - Standalone Works
export const singularities = [
  {
    id: 10,
    title: "Fin Neato",
    year: "2025",
    dimensions: "11x14",
    series: "Singularities",
    image: "/fin_neato.png",
    description: "An Aquatic Kaleidoscope of chaotic energy"
  },
  {
    id: 11,
    title: "A Negative",
    year: "2025",
    dimensions: "22x25",
    series: "Singularities",
    image: "/a_negative.png",
    description: "An exploration of inverted space and structural absence, defining form through what is removed"
  }
];

// The Archives - Prototypes, Brand Concepts, and Process Work
export const archives = [
  {
    id: 12,
    title: "Copper Amber",
    year: "2024",
    dimensions: "13x13",
    category: "Form Study",
    series: "The Archives",
    image: "/copper_amber.jpg"
  },
  {
    id: 13,
    title: "DSENTRY",
    year: "2024",
    dimensions: "13x13",
    category: "Form Study",
    series: "The Archives",
    image: "/dsentry.jpg"
  },
  {
    id: 14,
    title: "Gold Blackout _ Daydream (demo)",
    year: "2024",
    dimensions: "Variable",
    category: "Conceptual Study",
    series: "The Archives",
    image: "/gold_blackout_daydream.png"
  }
];

// Apparel Study
export const apparelStudy = [
  {
    id: 15,
    title: "Study No. 001 FIN NEATO",
    year: "2025",
    status: "Inquire Within",
    series: "Apparel Study",
    images: [
      "/fin_neato_apparel.png",
      "/fin_neato_folded_1.jpg",
      "/fin_neato_folded_2.jpg"
    ],
    description: "Study number 001, Fin Neato explores the placement and scale of the series branding on textile. This piece serves as a prototype for the evolution of the brand's visual language."
  }
];

export const seriesDescriptions = {
  kingfishProtocol: "A systematic record of emergence serving as the formal documentation of strategic development and structural authority within my work. The series is predicated on the kingfisher bird, Alcedinidae, utilizing its structural precision to inform The Protocol's development.",
  unexpectedAutopsy: "A series exploring unexpected intersections and analytical deconstruction.",
  singularities: "Standalone works that exist outside of formal series—each piece a singular exploration.",
  archives: "Prototypes, brand concepts, and process work—the raw materials of creative development.",
  apparelStudy: "Explorations in textile application and wearable art—examining how visual language translates across mediums."
};

export const artistInfo = {
  name: "Michael Eduarde Thurston",
  statement: "My work is an exploration of recomposition, decomposition, pattern repetition, deconstruction, and synchronized chaos. The process includes direct digital execution among other mediums—each piece emerges from a deliberate investigation of structure and dissolution. I examine how forms can be broken apart and reassembled, creating visual systems that oscillate between order and entropy."
};

export const contactInfo = {
  email: "murkedirtygraphics@gmail.com",
  instagram: "@murkedirtygraphics"
};
